export default __webpack_public_path__ + "static/media/fao-logo-es.a6adadcb.svg";